const vote = () =>
    import(/* webpackChunkName: "vote" */ '@/views/vote/index.vue');

export default [{
    path: '/vote',
    name: 'vote',
    components: {
        default: vote
    },
    meta: {
        title: '投票活动',
        login: true,
        hideMenu: true
    }
}]
